export const generateCSV = async ({ data, fileName }) => {
  // use XLSX generate a file csv, with headers and data
  const XLSX = await import("xlsx");
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "file");
  // donwload file .csv
  XLSX.writeFile(wb, fileName);
};
